import { api, publicApi } from "./http";

export async function changePassword(new_password) {
	const res = await api.post("/api/auth/change-password/", { new_password });
	return res.data;
}

export async function login({ username, password, act_as, keep_session }) {
	const payload = { username, password };
	if (act_as) payload.act_as = act_as;
	if (keep_session != null) payload.keep_session = Boolean(keep_session);

	const res = await publicApi.post("/api/auth/login/", payload);
	return res.data; // { access, roles, active_role, refresh }
}

export async function logout() {
	const res = await api.post("/api/auth/logout/", {});
	return res.data;
}

// Perfil del usuario logueado (para navbar/portal)
export async function me() {
	const res = await api.get("/api/auth/me/");
	return res.data;
}

/** Actualiza datos propios (nombre, apellido, correo, usuario de acceso). PATCH /api/auth/me/ */
export async function patchMe(payload) {
	const res = await api.patch("/api/auth/me/", payload);
	return res.data;
}

let localRefreshPromise = null;

export async function refresh() {
	if (!localRefreshPromise) {
		localRefreshPromise = publicApi.post("/api/auth/refresh/", {}).finally(() => {
			// Limpiar la promesa después de unos segundos o inmediatamente
			setTimeout(() => { localRefreshPromise = null; }, 1000);
		});
	}
	const res = await localRefreshPromise;
	return res.data; // { access, active_role, refresh }
}

export async function switchRole(act_as) {
	const payload = { act_as };
	const res = await api.post("/api/auth/switch-role/", payload);
	return res.data; // { access, roles, active_role, refresh }
}

export async function requestPasswordReset(identifier) {
	// Usamos publicApi porque el usuario no está logueado
	const res = await publicApi.post("/api/auth/request-reset/", { identifier });
	return res.data;
}

export async function resetPasswordConfirm(uid, token, new_password) {
	const res = await publicApi.post("/api/auth/reset-password-confirm/", { uid, token, new_password });
	return res.data;
}

export async function getOnlineUsers() {
	const res = await api.get("/api/auth/online-users/");
	return res.data;
}
